import { render, staticRenderFns } from "./importdata-jaminan.vue?vue&type=template&id=4195bc16&scoped=true&"
import script from "./importdata-jaminan.vue?vue&type=script&lang=js&"
export * from "./importdata-jaminan.vue?vue&type=script&lang=js&"
import style0 from "./importdata-jaminan.vue?vue&type=style&index=0&id=4195bc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195bc16",
  null
  
)

export default component.exports